import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/PricingPage.css';

function PricingPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const plans = [
        {
            name: 'Básico',
            price: 'Grátis',
            period: 'para sempre',
            description: 'Ideal para começar a organizar seu negócio',
            features: [
                'Até 50 produtos cadastrados',
                'Controle básico de vendas',
                'Controle de despesas',
                'Dashboard simplificado',
                'Até 20 clientes',
                'Suporte por email',
            ],
            limitations: [
                'Sem relatórios avançados',
                'Sem gestão de pedidos',
                'Sem exportação de dados',
            ],
            cta: 'Começar Grátis',
            highlighted: false,
            priceValue: 0,
        },
        {
            name: 'Profissional',
            price: 'R$ 29,90',
            period: '/mês',
            description: 'Para negócios em crescimento',
            features: [
                'Produtos ilimitados',
                'Controle completo de vendas',
                'Controle de despesas por categoria',
                'Dashboard com gráficos',
                'Clientes ilimitados',
                'Gestão de pedidos',
                'Relatórios intermediários',
                'Exportação CSV básica',
                'Suporte prioritário',
            ],
            limitations: [],
            cta: 'Assinar Agora',
            highlighted: true,
            priceValue: 29.90,
            popular: true,
        },
        {
            name: 'Premium',
            price: 'R$ 59,90',
            period: '/mês',
            description: 'Controle total do seu negócio',
            features: [
                'Tudo do Profissional +',
                'Relatórios completos e avançados',
                'Análise de lucratividade por produto',
                'Gráficos de evolução mensal',
                'Distribuição de produtos',
                'Análise de despesas por categoria',
                'Ranking de produtos mais vendidos',
                'Exportação completa de dados',
                'Múltiplos formatos de exportação',
                'Suporte VIP com resposta em 24h',
                'Treinamento personalizado',
            ],
            limitations: [],
            cta: 'Assinar Premium',
            highlighted: false,
            priceValue: 59.90,
        },
    ];

    return (
        <div className="pricing-page">
            {/* Header */}
            <div className="pricing-header">
                <Link to="/" className="back-home">
                    <i className="bi bi-arrow-left"></i> Voltar para Home
                </Link>
            </div>

            {/* Hero */}
            <section className="pricing-hero">
                <h1 className="pricing-title">Escolha o Plano Ideal para Seu Negócio</h1>
                <p className="pricing-subtitle">
                    Comece grátis e faça upgrade quando precisar de mais recursos
                </p>
            </section>

            {/* Plans */}
            <section className="plans-section">
                <div className="plans-container">
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className={`plan-card ${plan.highlighted ? 'highlighted' : ''}`}
                        >
                            {plan.popular && (
                                <div className="popular-badge">Mais Popular</div>
                            )}

                            <div className="plan-header">
                                <h3 className="plan-name">{plan.name}</h3>
                                <div className="plan-price">
                                    <span className="price">{plan.price}</span>
                                    <span className="period">{plan.period}</span>
                                </div>
                                <p className="plan-description">{plan.description}</p>
                            </div>

                            <div className="plan-features">
                                <h4>O que está incluído:</h4>
                                <ul className="features-list">
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx}>
                                            <i className="bi bi-check-circle-fill"></i>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                {plan.limitations.length > 0 && (
                                    <>
                                        <h4 className="limitations-title">Limitações:</h4>
                                        <ul className="limitations-list">
                                            {plan.limitations.map((limitation, idx) => (
                                                <li key={idx}>
                                                    <i className="bi bi-x-circle-fill"></i>
                                                    {limitation}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>

                            <div className="plan-cta">
                                <Link
                                    to={`/registro?plan=${plan.name.toLowerCase()}`}
                                    className={`btn ${plan.highlighted ? 'btn-primary' : 'btn-outline'}`}
                                >
                                    {plan.cta}
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Comparison Table */}
            <section className="comparison-section">
                <div className="container">
                    <h2 className="section-title">Compare os Planos</h2>
                    <div className="comparison-table-wrapper">
                        <table className="comparison-table">
                            <thead>
                                <tr>
                                    <th>Recurso</th>
                                    <th>Básico</th>
                                    <th>Profissional</th>
                                    <th>Premium</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Produtos</td>
                                    <td>Até 50</td>
                                    <td>Ilimitados</td>
                                    <td>Ilimitados</td>
                                </tr>
                                <tr>
                                    <td>Clientes</td>
                                    <td>Até 20</td>
                                    <td>Ilimitados</td>
                                    <td>Ilimitados</td>
                                </tr>
                                <tr>
                                    <td>Controle de Vendas</td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Controle de Despesas</td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Dashboard</td>
                                    <td>Básico</td>
                                    <td>Com Gráficos</td>
                                    <td>Completo</td>
                                </tr>
                                <tr>
                                    <td>Gestão de Pedidos</td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Relatórios</td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td>Intermediários</td>
                                    <td>Completos</td>
                                </tr>
                                <tr>
                                    <td>Exportação de Dados</td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td>CSV Básico</td>
                                    <td>Completa</td>
                                </tr>
                                <tr>
                                    <td>Análise de Lucratividade</td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Gráficos Avançados</td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td><i className="bi bi-x-lg text-danger"></i></td>
                                    <td><i className="bi bi-check-lg text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Suporte</td>
                                    <td>Email</td>
                                    <td>Prioritário</td>
                                    <td>VIP (24h)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section className="faq-section">
                <div className="container">
                    <h2 className="section-title">Perguntas Frequentes</h2>
                    <div className="faq-grid">
                        <div className="faq-item">
                            <h3>Posso mudar de plano depois?</h3>
                            <p>Sim! Você pode fazer upgrade ou downgrade a qualquer momento. As mudanças são aplicadas imediatamente.</p>
                        </div>
                        <div className="faq-item">
                            <h3>O plano Básico é realmente grátis?</h3>
                            <p>Sim, é 100% gratuito para sempre. Sem pegadinhas, sem cartão de crédito necessário.</p>
                        </div>
                        <div className="faq-item">
                            <h3>Posso cancelar a qualquer momento?</h3>
                            <p>Sim, você pode cancelar sua assinatura a qualquer momento, sem multas ou taxas de cancelamento.</p>
                        </div>
                        <div className="faq-item">
                            <h3>Como funciona o pagamento?</h3>
                            <p>Aceitamos pagamentos mensais via Mercado Pago. Você pode pagar com cartão de crédito ou PIX.</p>
                        </div>
                        <div className="faq-item">
                            <h3>Meus dados ficam salvos se eu mudar de plano?</h3>
                            <p>Sim! Todos os seus dados permanecem salvos. Você só ganha ou perde acesso a recursos específicos.</p>
                        </div>
                        <div className="faq-item">
                            <h3>Tem período de teste gratuito?</h3>
                            <p>O plano Básico já é gratuito! Para os planos pagos, você pode começar e cancelar no primeiro mês se não gostar.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Final */}
            <section className="final-cta">
                <div className="container">
                    <h2>Pronto para começar?</h2>
                    <p>Escolha seu plano e organize seu negócio hoje mesmo</p>
                    <Link to="/registro" className="btn btn-primary btn-lg">
                        Criar Conta Grátis
                    </Link>
                </div>
            </section>
        </div>
    );
}

export default PricingPage;
